import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Avatar, Box, Typography } from "@mui/material";
import {
	ExitToApp as ExitToAppIcon,
	Settings as SettingsIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { endSession } from "../../utils/session";

export default function UserComponent({ variant }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { user } = useUser();
	const navigate = useNavigate();
	const open = Boolean(anchorEl);

	const isSidebar = variant === "sidebar";

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleConfiguracoes = () => {
		setAnchorEl(null);
		navigate("/configuracoes");
	};

	const handleLogout = async () => {
		await endSession();
		localStorage.clear();
		window.location.href = "/";
	};

	return (
		<div>
			<Button
				id="basic-button"
				aria-controls={open ? "basic-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				sx={{
					bgcolor: isSidebar ? "rgba(255,255,255,0.15)" : "#1a9e8f",
					color: "white",
					width: isSidebar ? "100%" : "auto",
					minWidth: isSidebar ? "100%" : { xs: "auto", sm: "180px" },
					maxHeight: "50px",
					borderRadius: "8px",
					display: "flex",
					justifyContent: isSidebar ? "flex-start" : "center",
					m: 0,
					px: isSidebar ? 1.5 : { xs: 0, sm: 2 },
					"&:hover": {
						bgcolor: isSidebar ? "rgba(255,255,255,0.25)" : "#158f80",
					},
				}}
			>
				<Avatar sx={{ width: 32, height: 32, bgcolor: isSidebar ? "rgba(255,255,255,0.2)" : undefined }}>
					{user?.name?.substring(0, 1) ?? "N"}
				</Avatar>
				<Box
					sx={{
						display: isSidebar ? "flex" : { xs: "none", sm: "flex" },
						flexDirection: "column",
						alignItems: "start",
						justifyContent: "center",
						p: 0,
						m: 0,
						ml: 1,
					}}
				>
					<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
						{user?.name ?? "Não definido"}
					</Typography>
				</Box>
			</Button>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
				anchorOrigin={{
					vertical: isSidebar ? "top" : "bottom",
					horizontal: isSidebar ? "right" : "right",
				}}
				transformOrigin={{
					vertical: isSidebar ? "top" : "top",
					horizontal: isSidebar ? "left" : "right",
				}}
				sx={{
					p: 0,
					ml: isSidebar ? 1 : 0,
				}}
			>
				<MenuItem
					sx={{
						color: "gray",
						display: "flex",
						m: 0,
					}}
					onClick={handleConfiguracoes}
				>
					<SettingsIcon />
					<Typography sx={{ textTransform: "none", pl: 1 }}>
						Configurações
					</Typography>
				</MenuItem>
				<MenuItem
					sx={{
						color: "gray",
						display: "flex",
						m: 0,
					}}
					onClick={handleLogout}
				>
					<ExitToAppIcon />
					<Typography sx={{ textTransform: "none", pl: 1 }}>
						Sair da conta
					</Typography>
				</MenuItem>
			</Menu>
		</div>
	);
}
